"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLICK = 'click';
exports.HOVER = 'hover';
//# sourceMappingURL=constants.js.map